import { Component, inject, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TeamDetailsService } from '../team-details.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { VerifyEmailComponent } from '../verify-email/verify-email.component';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ToastService } from '../../../_core/services/toast.service';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss'],
  standalone: false
})
export class ConfirmEmailComponent implements OnInit {

  private modalController = inject(ModalController);
  @Input() displayEmail!: string;
  email: string = "";
  @Input() teamId!: string;
  private readonly destroy$: Subject<void> = new Subject();
  isLoading: boolean = true;

  constructor(
    private teamDetailsService: TeamDetailsService,
    private toastService: ToastService
  ) {

  }

  ngOnInit() { }

  submit(event: Event) {
    // this.modalController.dismiss({ confirmed: true, email: this.email, id: this.userId });
    event.preventDefault();
    event.stopPropagation();
    if (this.isValidEmail(this.email)) {
      this.claimCoach(this.email);
    } else {
      this.toastService.presentToast('You must enter valid email address.');
    }
  }

  isValidEmail(email: string): boolean {
    // Allow only .edu or .com emails
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(edu|com)$/i;
    return emailRegex.test(email);
  }


  onEmailInput(event: any) {
    this.email = event.target.value;
  }

  close() {
    this.modalController.dismiss();
  }

  async claimCoach(email: string) {
    if (this.teamId) {
      this.teamDetailsService
        .startClaimCoach(this.teamId, email)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => this.isLoading = false))
        .subscribe({
          next: async (res) => {
            this.isLoading = false;
            // if (res?.data) {
            await this.verifyEmail(email);
            // }
          },
          error: async (err) => {
            this.isLoading = false;
            this.toastService.presentDangerToast(err?.error?.message || err?.message || 'Error initiating claim, Please try again.');
          }
        });
    }
  }

  async verifyEmail(email: string) {
    const modal = await this.modalController.create({
      component: VerifyEmailComponent,
      componentProps: {
        email: email,
        teamId: this.teamId
      }
    });

    modal.onDidDismiss().then((result) => {
      if (result.data) {
        if (result.data?.confirmed) {
          this.modalController.dismiss({ confirmed: true });
        }
      }
    });

    await modal.present();

    // const { data } = await modal.onDidDismiss();

    //this.official = data;
  }

}
